module.exports = (button, cloneSelector, sourceKeypath, maxKeypath) ->
	unless _.isArray @get sourceKeypath
		@set sourceKeypath, new Array 1

	$button = $ button
	$buttonParent = $button.parent()

	getCount = => @get(sourceKeypath).length
	getMax = => @get maxKeypath
	hideButton = -> $buttonParent.hide()
	showButton = -> $buttonParent.show()

	@on 'close', (e) ->
		@splice sourceKeypath, e.index.i, 1

		showButton() if getMax() > getCount()

	@on 'clone', (e) ->
		@push sourceKeypath, 0
			.then (count) =>
				$els = $ cloneSelector
				$el = $els.eq count - 1
				$select = $el.find 'select'

				$select.selectric
					arrowButtonMarkup: '<b class="btn">&#9662;</b>'

				hideButton() if getMax() <= count

	@observe maxKeypath, (newValue, oldValue) ->
		return if _.isUndefined newValue
		newValue = if _.isNumber newValue then newValue else parseInt newValue
		return if _.isNaN newValue

		if newValue < oldValue and newValue < getCount()
			toRemove = oldValue - newValue

			@splice sourceKeypath, newValue, toRemove

		hideButton() if newValue <= oldValue and $buttonParent.is ':visible'
		showButton() if newValue > oldValue and $buttonParent.is ':hidden'

	return {
		teardown: ->
	}


/** WEBPACK FOOTER **
 ** ./assets/coffee/decorators/cloner.coffee
 **/